import "../../styles/components/ToolBarLeftPanel.scss";
import ButtonSvg from "../../images/Buttongrey.svg";
import ImgSvg from "../../images/Imagegrey.svg";
import TextSvg from "../../images/Text Grey.svg";
import TextSvgblue from "../../images/TextBlue (3).svg";
import ShapesSvg from "../../images/Shapesgrey.svg";
import ButtonBlue from "../../images/Buttonblue.svg";
import ImgBlue from "../../images/Imageblue.svg";
import ShapesBlue from "../../images/ShapesBlue.svg";
import TextWindow from "./TextWindow.js";
import ButtonWindow from "./ButtonWindow.js";
import ShapesWindow from "./ShapesWindow";
import ModuleWindow from "./ModuleWindow";
import ScrollISIRefFootNotesBlue from "../../images/ScrollFootNotesBlue.svg";
import ScrollISIRefFootNotes from "../../images/ScrollFootNote.svg";
import { TEXT, IMAGE, BUTTON } from "../../Uitls/ComponentType";
import TimelineBlue from "../../images/LeftPanelIcons/Layerblue.svg";
import nounLayersBlack from "../../images/Layergrey.svg";
import ImageWindow from "./ImageWindow";
import ExpandLayers from "./ExpandLayers";
import LayersWindow from "./LayersWindow.js";
import { Tooltip } from "@mui/material";
import ScrollBarWindow from "./ScrollBarWindow.js";

const SideBarLeftPanel = (props) => {
  const {
    bannerId,
    toggleAnimatedBanner,
    showBannertype,
    showAssettype,
    setModules,
    modules,
    getLayerDetails,
    sendAtomDetails2Canvas,
    openTimeLine,
    selectedComponent,
    setSelectedComponent,
    layerId,
    imageOnCanvas,
    linkImages,
    setLinkImages,
    getLinkImages,
    imageCount,
    setImageCount,
    playPause,
    linkedModulesType,
    setLinkedModulesType,
    loadingModules,
    setLoadingModules,
    setVeevaModuleCardData,
    veevaModuleCardData,
    playPauseRef,
    toggleHideComp,
    toggleLockComp,
    setMultiSelectedComps,
    setSelectedIndex,
    selectedIndex,
    openElements,
    handleOpenElement,
    handleCloseElement,
    setBgClass,
    selectedModulecards,
    setSelectedModulecards,
    setIsNext,
    openModulesModal,
    setOpenModulesModal,
    openModulesScreen,
    setOpenModulesScreen,
    handleOpenModuleModal,
    showModulesSection,
    setShowModulesSection,
    isReferenceFootnotes,
    isReferenceFootnotesScrollbar,
    editComponent,
    isOneTimeAsset,
  } = props;

  const sidebarIcons = [
    {
      src: (
        <>
          {" "}
          <img
            id="txt-img"
            alt="txt-img"
            src={
              selectedIndex === 0 && openElements.Text ? TextSvgblue : TextSvg
            }
          ></img>
        </>
      ),
      iconType: TEXT,
      toolTipText: "Text",
    },
    {
      src: (
        <img
          id="buttonType"
          alt="buttonType"
          src={
            selectedIndex === 1 && openElements.Button === true
              ? ButtonBlue
              : ButtonSvg
          }
        ></img>
      ),
      iconType: BUTTON,
      toolTipText: "Button",
    },
    {
      src: (
        <>
          {" "}
          <img
            id="img-img"
            alt="img-img"
            src={selectedIndex === 2 && openElements.Image ? ImgBlue : ImgSvg}
          ></img>
        </>
      ),
      iconType: IMAGE,
      toolTipText: "Image",
      type: (
        <p
          className={
            openElements.Image === true
              ? "sideBarTextonClick"
              : "sideBarTypeNotOnclik"
          }
        >
          Image
        </p>
      ),
    },
    {
      src: (
        <>
          {" "}
          <img
            id="shape-img"
            alt="shape-img"
            src={
              selectedIndex === 3 && openElements.Shapes
                ? ShapesBlue
                : ShapesSvg
            }
          ></img>
          {/* {openElements.Shapes && (
            <ShapesWindow
              handleCloseElement={handleCloseElement}
              getLayerDetails={getLayerDetails}
            />
          )} */}
        </>
      ),
      iconType: "Shapes",
      toolTipText: "Shapes",
    },
    {
      src: (
        <>
          {" "}
          <img
            id="scrollbar-img"
            alt="scrollbar-img"
            src={
              selectedIndex === 4 && openElements.Scrollbar
                ? ScrollISIRefFootNotesBlue
                : ScrollISIRefFootNotes
            }
          ></img>
        </>
      ),
      iconType: "Scrollbar",
      toolTipText: isOneTimeAsset
        ? "Scrollbar"
        : "Scrollbar & Reference and Footnotes",
    },

    {
      src: (
        <>
          <img
            id="timeline-img"
            alt="timeline-img"
            className="timelineImg"
            src={
              openTimeLine || openElements.Layers === true
                ? TimelineBlue
                : nounLayersBlack
            }
          ></img>
        </>
      ),
      iconType: "Layers",
      toolTipText: "Layers",
    },
  ];
  const openWindow = Object.values(openElements).some((elem) => elem === true);

  const getStyles = (index) => {
    if (index === 6) {
      return index === selectedIndex && openWindow
        ? "iconsActive flex-fill listItems timelinePanelsidebar"
        : "iconsInactive flex-fill listItems timelinePanelsidebar";
    } else {
      return index === selectedIndex && openWindow
        ? "iconsActive flex-fill listItems"
        : "iconsInactive flex-fill listItems";
    }
  };
  const getborderStyles = (index) => {
    return index === selectedIndex && openWindow
      ? "iconsleftpanel "
      : "iconsleftpanelInactive ";
  };

  return (
    <>
      <div
        className="sideBarLeftpanel"
        style={{ pointerEvents: !playPause.animationCompleted && "none" }}
      >
        <ul
          className={
            showAssettype === "Banner"
              ? "d-flex mb-0 listItemSideBar"
              : "d-flex mb-0 listItemSideBartemp"
          }
        >
          {sidebarIcons.map((data, index) => {
            return (
              <>
                <li
                  className={getStyles(index)}
                  key={index}
                  onClick={(e) => {
                    if (playPauseRef.current.animationCompleted) {
                      setBgClass(true);
                      handleOpenElement(data.iconType);
                      setSelectedIndex(index);
                      if (data.iconType === "Image") {
                        //  getLayerDetails(e.target.id, IMAGE);
                        getLinkImages(bannerId);
                      }
                      if (data.iconType !== "Layers") setBgClass(true);
                    }
                  }}
                >
                  {" "}
                  <Tooltip title={data.toolTipText}>
                    <div className={getborderStyles(index)}>{data.src}</div>
                  </Tooltip>
                </li>
              </>
            );
          })}
        </ul>
        {openElements.Text && (
          <TextWindow
            handleCloseElement={handleCloseElement}
            getLayerDetails={getLayerDetails}
          />
        )}
        {openElements.Button && (
          <ButtonWindow
            handleCloseElement={handleCloseElement}
            getLayerDetails={getLayerDetails}
          />
        )}
        {openElements.Image && (
          <ImageWindow
            key={bannerId}
            handleCloseElement={handleCloseElement}
            selectedComponent={selectedComponent}
            setSelectedComponent={setSelectedComponent}
            layerId={layerId}
            imageOnCanvas={imageOnCanvas}
            linkImages={linkImages}
            setLinkImages={setLinkImages}
            getLinkImages={getLinkImages}
            imageCount={imageCount}
            setImageCount={setImageCount}
            getLayerDetails={getLayerDetails}
          />
        )}
        {openElements.Shapes && (
          <ShapesWindow
            handleCloseElement={handleCloseElement}
            getLayerDetails={getLayerDetails}
          />
        )}
        {openElements.Module && (
          <ModuleWindow
            handleOpenModuleModal={handleOpenModuleModal}
            setOpenModulesModal={setOpenModulesModal}
            openModulesScreen={openModulesScreen}
            setOpenModulesScreen={setOpenModulesScreen}
            openModulesModal={openModulesModal}
            setModules={setModules}
            modules={modules}
            openTimeLine={openTimeLine}
            handleCloseElement={handleCloseElement}
            getLayerDetails={getLayerDetails}
            sendAtomDetails2Canvas={sendAtomDetails2Canvas}
            linkedModulesType={linkedModulesType}
            setLinkedModulesType={setLinkedModulesType}
            loadingModules={loadingModules}
            setLoadingModules={setLoadingModules}
            setVeevaModuleCardData={setVeevaModuleCardData}
            veevaModuleCardData={veevaModuleCardData}
            selectedModulecards={selectedModulecards}
            setSelectedModulecards={setSelectedModulecards}
            setIsNext={setIsNext}
            showModulesSection={showModulesSection}
            setShowModulesSection={setShowModulesSection}
          />
        )}
        {openElements.Layers && !toggleAnimatedBanner && (
          <ExpandLayers
            showBannertype={showBannertype}
            handleCloseElement={handleCloseElement}
            layerCompData={props.layerCompData}
            setLayerCompData={props.setLayerCompData}
            selectedComponent={selectedComponent}
            setSelectedComponent={setSelectedComponent}
            toggleLockComp={toggleLockComp}
            toggleHideComp={toggleHideComp}
            toggleAnimatedBanner={toggleAnimatedBanner}
            playPause={playPause}
            setMultiSelectedComps={setMultiSelectedComps}
          />
        )}
        {openElements.Layers && toggleAnimatedBanner && <LayersWindow />}
        {openElements.Scrollbar && (
          <ScrollBarWindow
            isOneTimeAsset={isOneTimeAsset}
            editComponent={editComponent}
            isReferenceFootnotesScrollbar={isReferenceFootnotesScrollbar}
            isReferenceFootnotes={isReferenceFootnotes}
            handleCloseElement={handleCloseElement}
            getLayerDetails={getLayerDetails}
          />
        )}
      </div>
    </>
  );
};

export default SideBarLeftPanel;
